import { Controller }  from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['checkbox']

  static values = {
    maxCategories: Number
  }

  connect() {
    // Set the initial state of parent checkboxes
    this.toggleCheckboxes()
  }

  // When a child category is selected, we want to disable other groups of categories
  toggleCheckboxes() {
    const topLevelCategories = this.checkboxTargets.filter(cb => cb.dataset.depth == "1")
    const secondLevelCategories = this.checkboxTargets.filter(cb => cb.dataset.depth == "2")

    // The categories that can be selected are the "leaf" nodes, ie categories
    // without any children
    const selectableCategories = this.checkboxTargets.filter(cb => {
      return !this.checkboxTargets.some(c => c.dataset.parentId === cb.dataset.categoryId)
    })

    // What has been selected/checked
    const selectedCategories = this.checkboxTargets.filter(cb => cb.checked)
    const selectedCategoryIds = selectedCategories.map(cb => cb.dataset.categoryId)
    const selectedChildrenCategories = secondLevelCategories.filter(cb => cb.checked)
    const parentsOfSelectedChildren = selectedChildrenCategories.map(cb => this.checkboxTargets.find(c => c.dataset.categoryId === cb.dataset.parentId))
    const childrenOfSelected = this.checkboxTargets.filter(cb => selectedCategoryIds.includes(cb.dataset.parentId))

    // Start by disabling everything
    this.disableCheckboxes(this.checkboxTargets)

    if (selectedCategories.length > 0) {
      // Enable checked checkboxes, so we can turn off the categories we're in
      this.enableCheckboxes(selectedCategories)

      // If there are any children in the selected categories enable those and
      // disable their parent checkbox
      if (childrenOfSelected.length > 0) {
        this.enableCheckboxes(childrenOfSelected)

        // Disable parent categories so they aren't submitted.
        this.disableCheckboxes(parentsOfSelectedChildren)
      }

      const selectedSelectableCategories = selectableCategories.filter(cb => cb.checked)
      if (selectedSelectableCategories.length >= this.maxCategoriesValue) {
        // Disable all non-selected categories
        selectableCategories.forEach(cb => {
          if (!cb.checked) {
            cb.disabled = true
          }
        })
      }
    } else {
      // Enable top-level categories for initial selection
      this.enableCheckboxes(topLevelCategories)
    }
  }

  disableCheckboxes(checkboxes) {
    checkboxes.forEach(cb => {
      cb.disabled = true
    })
  }

  enableCheckboxes(checkboxes) {
    checkboxes.forEach(cb => {
      cb.disabled = false
    })
  }
}
